<markdown [data]="readme" class="variable-binding"></markdown>
